module.exports = __webpack_public_path__ + "img/logo-full-text.72302d7c.png";